import { Login } from "@/components/Login/Forms/Login";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

export default function LoginModal({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Login</DialogTitle>
                    <DialogDescription>
                        Login to your account to continue
                    </DialogDescription>
                </DialogHeader>
                <Login />
                <Button variant="outline" onClick={onClose} className="mt-2">
                    Close
                </Button>
            </DialogContent>
        </Dialog>
    )
}